import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";
// import SplashScreen from "./pages/SplashScreen";
import LoginScreen from "./pages/LoginScreen";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordOTP from "./pages/ForgotPasswordOTP";
import HomeScreen from "./pages/HomeScreen";
import CalendarScreen from "./pages/CalendarScreen";
import AppointmentScreen from "./pages/AppointmentScreen";
import AppointmentSecondaryScreen from "./pages/AppointmentSecondaryScreen";
import TreatmentPlanScreen from "./pages/TreatmentPlanScreen";
import AppointmentView from "./pages/AppointmentViewScreen";
import SwitchAlignersScreen from "./pages/SwitchAlignersScreen";
import ViewSwitchedAligners from "./pages/ViewSwitchedAligners";
import ClinicScreen from "./pages/ClinicScreen";
import KnowledgeScreen from "./pages/KnowledgeScreen";
import ProfileScreen from "./pages/ProfileScreen";
import DiscussionScreen from "./pages/DiscussionScreen";
import ChangePassword from "./pages/ChangePassword";
import TeethProfile from "./pages/TeethProfile";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./Layout";
import OpenLayout from "./OpenLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatbotScreen from "./pages/ChatbotScreen";
import "./App.css";
import CaseScreen from "./pages/CaseScreen";
import AlignerSchedule from "./pages/AlignerSchedule";

const App = () => {
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        {/* Open Routes */}
        <Route element={<OpenLayout />}>
          {/* <Route path="/" element={<SplashScreen />} /> */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password-otp" element={<ForgotPasswordOTP />} />
        </Route>

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/calendar" element={<CalendarScreen />} />
          <Route path="/appointment" element={<AppointmentScreen />} />
          <Route
            path="/appointment-secondary"
            element={<AppointmentSecondaryScreen />}
          />
          <Route path="/treatment-plan" element={<TreatmentPlanScreen />} />
          <Route path="/appointment-view" element={<AppointmentView />} />
          <Route path="/clinic" element={<ClinicScreen />} />
          <Route path="/knowledge" element={<KnowledgeScreen />} />
          <Route path="/discussion" element={<DiscussionScreen />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/profile" element={<ProfileScreen />} />
          <Route path="/teeth-profile" element={<TeethProfile />} />
          <Route path="/smile-bot" element={<ChatbotScreen />} />
          <Route path="/cases" element={<CaseScreen />} />
          <Route path="/view-case" element={<TreatmentPlanScreen />} />
          <Route path="/aligner-schedule" element={<AlignerSchedule />} />
          <Route path="/switch-aligners" element={<SwitchAlignersScreen />} />
          <Route path="/view-aligner-plan" element={<ViewSwitchedAligners />} />
        </Route>

        {/* Redirect for Unknown Routes */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
